var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIncreaseImg = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  id: "Trending-Content--Streamline-Core.svg",
  height: 16,
  width: 16,
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Trending Content Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "trending-content--lit-flame-torch-trending"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  fill: "#FF6B3D",
  d: "M7.0285714285714285 0.6342857142857143a0.44457142857142856 0.44457142857142856 0 0 0 -0.456 0 0.29714285714285715 0.29714285714285715 0 0 0 -0.06857142857142856 0.38857142857142857c1.4022857142857144 2.4262857142857146 1.6982857142857142 5.732571428571428 -0.21714285714285714 7.555428571428571a6.291428571428571 6.291428571428571 0 0 1 -1.7085714285714286 -2.278857142857143 4.434285714285714 4.434285714285714 0 0 0 -2.28 3.9885714285714284 5.357714285714285 5.357714285714285 0 0 0 5.699428571428571 5.129142857142857c3.6697142857142855 0 5.573714285714285 -2.278857142857143 5.6982857142857135 -5.129142857142857C13.84457142857143 6.868571428571428 11.417142857142856 2.662857142857143 7.0285714285714285 0.6342857142857143Z",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  stroke: "#FD3800",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M7.0285714285714285 0.6342857142857143a0.44457142857142856 0.44457142857142856 0 0 0 -0.456 0 0.29714285714285715 0.29714285714285715 0 0 0 -0.06857142857142856 0.38857142857142857c1.4022857142857144 2.4262857142857146 1.6982857142857142 5.732571428571428 -0.21714285714285714 7.555428571428571a6.291428571428571 6.291428571428571 0 0 1 -1.7085714285714286 -2.278857142857143 4.434285714285714 4.434285714285714 0 0 0 -2.28 3.9885714285714284 5.357714285714285 5.357714285714285 0 0 0 5.699428571428571 5.129142857142857c3.6697142857142855 0 5.573714285714285 -2.278857142857143 5.6982857142857135 -5.129142857142857C13.84457142857143 6.868571428571428 11.417142857142856 2.662857142857143 7.0285714285714285 0.6342857142857143Z",
  strokeWidth: 1
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIncreaseImg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/increase-img.ff3c2415ddc50456ade450779f3fad49.svg";